import { c as _c } from "react/compiler-runtime";
import { FileSourceEnum } from '@systemeio/file-manager';
import { advancedTextEditorExtensions, TipTapEditor, TipTapEditorProps } from '@systemeio/tip-tap';
import { STORE_TOOLBAR_ID } from 'pages/stores/[storeId]';
import { FC } from 'react';
import { FieldErrorAndDescription } from 'shared/components/form/field-error-and-description';
import { FieldLabel } from 'shared/components/form/field-label';
import useMediaQuery from 'shared/hooks/use-media-query';
import { getSSRDocument } from 'shared/utils/get-ssr-document';
type Props = {
  label?: string;
  required?: boolean;
  content: string;
  error?: string;
  statusIcon?: React.ReactNode;
} & TipTapEditorProps;
export const StoreTextEditor: FC<Props> = t0 => {
  const $ = _c(28);
  let content;
  let error;
  let label;
  let required;
  let rest;
  let statusIcon;
  if ($[0] !== t0) {
    ({
      label,
      required,
      content,
      error,
      statusIcon,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = content;
    $[2] = error;
    $[3] = label;
    $[4] = required;
    $[5] = rest;
    $[6] = statusIcon;
  } else {
    content = $[1];
    error = $[2];
    label = $[3];
    required = $[4];
    rest = $[5];
    statusIcon = $[6];
  }
  let t1;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getSSRDocument()?.getElementById(STORE_TOOLBAR_ID)?.clientHeight ?? 0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const storeToolbarHeight = t1;
  const {
    isLG
  } = useMediaQuery();
  const t2 = isLG ? "0" : `${storeToolbarHeight}px`;
  let t3;
  if ($[8] !== t2) {
    t3 = {
      top: t2
    };
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const toolbarStyles = t3;
  let t4;
  if ($[10] !== label || $[11] !== required) {
    t4 = <FieldLabel label={label} required={required} />;
    $[10] = label;
    $[11] = required;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== statusIcon) {
    t5 = statusIcon && <div className="absolute right-2 top-16 z-20 rounded-lg bg-white p-2 shadow-lg">{statusIcon}</div>;
    $[13] = statusIcon;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== content || $[16] !== rest || $[17] !== toolbarStyles) {
    t6 = <TipTapEditor extensions={advancedTextEditorExtensions} content={content} toolbarStyles={toolbarStyles} fileSource={FileSourceEnum.DigitalStore} {...rest} />;
    $[15] = content;
    $[16] = rest;
    $[17] = toolbarStyles;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t5 || $[20] !== t6) {
    t7 = <div className="relative">{t5}{t6}</div>;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== error) {
    t8 = <FieldErrorAndDescription error={error} />;
    $[22] = error;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== t4 || $[25] !== t7 || $[26] !== t8) {
    t9 = <div className="flex flex-col gap-1">{t4}{t7}{t8}</div>;
    $[24] = t4;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  return t9;
};